import { Bin, BinStatus } from '../../../../../types/bin';
import { Lot } from '../../../../../types/lot';
import { Order } from '../../../../../types/order';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';
import { ProductTransaction } from '../../../../../types/productTransaction';
import { StockLocation } from '../../../../../types/stock_location';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';

export namespace ActivityUtil {
  export function toText(
    item: any,
    productMasterData: Map<string, ProductMasterData>,
    orders: Map<string, Order>,
  ): string {
    if (item instanceof ProductMasterData) {
      return `${t(TranslationKey.update).singular.label} ${item.productName} (${item.productNumber})`;
    } else if (item instanceof StockLocation) {
      return `${t(TranslationKey.update).singular.label} ${item.name}`;
    } else if (item instanceof Order) {
      return `${t(TranslationKey.update).singular.label} ${t(TranslationKey.order).singular.label} ${item.number}`;
    } else if (item instanceof Bin) {
      return `${t(TranslationKey.update).singular.label} ${t(TranslationKey.bin).singular.label} ${item.name}`;
    } else if (item instanceof Lot) {
      return `${t(TranslationKey.update).singular.label} ${t(TranslationKey.lot).singular.label} ${item.number}`;
    } else if (item instanceof BinStatus) {
      return `${t(TranslationKey.update).singular.label} ${t(TranslationKey.binStatus).singular.label} ${item.status}`;
    } else if (item instanceof ProductTransaction) {
      return `${
        item.processedAt ? t(TranslationKey.processed).singular.label : t(TranslationKey.update).singular.label
      } Transaction ${productMasterData.get(item.product.pmdId || '')?.productNumber} (${
        t(TranslationKey.order).singular.label
      } ${orders.get(item.parentId || '')?.number}), ${t(TranslationKey.quantity).singular.label} ${
        item.product.processedQuantity || item.product.quantity
      }`;
    } else {
      return 'UNKNOWN';
    }
  }
}
